module.exports = __webpack_public_path__ + "static/media/figure-loader.137f6808.png";